import { alpha } from '@instructure/ui-color-utils';
var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    typography = _ref.typography,
    borders = _ref.borders,
    breakpoints = _ref.breakpoints,
    transitions = _ref.transitions;
  return {
    sidebarWidthClosed: spacing.xxLarge,
    sidebarWidthOpen: '22rem',
    sidebarBackgroundColor: colors.white,
    sidebarBorderWidth: borders.widthSmall,
    sidebarBorderColor: colors.tiara,
    sidebarColor: colors.oxford,
    sidebarZIndex: '5555',
    sidebarTransitionDuration: transitions.duration,
    infoHolderFontSize: typography.fontSizeXSmall,
    infoHolderBorderWidth: borders.widthSmall,
    infoHolderBorderColor: colors.tiara,
    infoHolderPadding: spacing.small,
    actionableInfoHoverBorderColor: colors.electric,
    actionableInfoBorderWidth: borders.widthLarge,
    questionNavigatorPadding: spacing.xxxSmall,
    headerSpacingPadding: "".concat(spacing.small, " ").concat(spacing.xSmall),
    pinnedSectionBackgroundColor: colors.porcelain,
    pinnedQuestionSpacing: spacing.small,
    pinnedQuestionFontSize: typography.fontSizeSmall,
    sidebarHeaderBorderWidth: borders.widthSmall,
    sidebarHeaderBorderColor: colors.tiara,
    descriptionFontSize: typography.fontSizeXSmall,
    descriptionFontColor: colors.slate,
    phoneBreakPoint: "max-width: ".concat(breakpoints.medium),
    focusBorderColor: colors.brand,
    focusOutlineColor: alpha(colors.brand, 50)
  };
};
export default generateComponentTheme;